import * as authAction from "../store/auth/login/actions";

import axios from "axios";
import {getUserToken} from './auth_helper'

//pass new generated access token here

//apply base url for axios
const API_URL = "";

const axiosApi = axios.create({
    baseURL: API_URL,
});
const axiosApiForm = axios.create({
    baseURL: API_URL,
});

function getUrl(config) {
    if (config.baseURL) {
        return config.url.replace(config.baseURL, "");
    }
    return config.url;
}
axiosApiForm.interceptors.response.use(
    response => response,
    error => Promise.reject(error)
);

export async function get(url, config = {}) {
    return await axiosApi.get(url, {...config }).then(response => response.data);
}

export async function post(url, data, config = {}) {
    const accessToken = JSON.parse(localStorage.getItem("accessToken"));
    const userToken = getUserToken();
    // console.log(userToken);
    let authorization = null;
    if (accessToken !== null) {
        authorization = `Bearer ${accessToken.access_token}`;
        // We have data!!
    }

    axiosApi.defaults.headers.common["Authorization"] = authorization;
    axiosApi.defaults.headers.common["TSOSESSIONID"] = userToken;


    // console.log(axiosApi.defaults)
    return axiosApi
        .post(url, Array.isArray(data) ? [...data] : {...data }, {...config })
        .then(response => response.data);
}
export async function postFormUrlencoded(url, data) {
    return axiosApiForm
        .post(url, data, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        })
        .then(response => response.data);
}
export async function postUpload(url, data) {
    const accessToken = JSON.parse(localStorage.getItem("accessToken"));
    const userToken = getUserToken()
    // console.log(userToken);
    let authorization = null;
    if (accessToken !== null) {
        authorization = `Bearer ${accessToken.access_token}`;
        // We have data!!
    }
    return axiosApi
        .post(url, data, { headers: { "Content-Type": "multipart/form-data" ,"Authorization":authorization,"TSOSESSIONID":userToken} })
        .then(response => response.data);
}

export async function put(url, data, config = {}) {
    return axiosApi
        .put(url, {...data }, {...config })
        .then(response => response.data);
}

export async function del(url, config = {}) {
    return await axiosApi
        .delete(url, {...config })
        .then(response => response.data);
}
export default {
    setupInterceptors: (store, history) => {
        axiosApi.interceptors.response.use(
            async response => {
                if (response.status === 401) {
                    try {
                        const value = localStorage.getItem("accessToken");
                        // console.log(value);
                        if (value !== null) {
                            // We have data!!
                            localStorage.clear();
                            store.dispatch({ type: UNAUTH_USER });
                            // NavigationService.navigate('AuthStackScreen');
                        }
                    } catch (error) {
                        // Error retrieving data
                        // console.log(error, "logged in client error");
                    }
                }
                // console.log(
                //     `%c ${response.status} - ${getUrl(response.config)}:`,
                //     "color: #008000; font-weight: bold",
                //     response
                // );
                return response;
            },
            error => {
                // console.log(error, "error console");
                if (error?.response?.status === 401) {
                    try {
                        const value = localStorage.getItem("accessToken");
                        // console.log(value);
                        // if (value !== null) {
                        //     // We have data!!
                            localStorage.clear();
                            store.dispatch(authAction.logout(history));
                        //     // NavigationService.navigate('AuthStackScreen');
                        // }
                    } catch (error) {
                        // Error retrieving data
                        // console.log(error, "logged in client error");
                    }
                } else {

                }
                if (error?.response?.status === 429) {
                    Alert.alert("Too many requests. Please try again later.");
                }
                // console.log(
                //     `%c ${error.response.status} - ${getUrl(error.response.config)}:`,
                //     "color: #a71d5d; font-weight: bold",
                //     error.response
                // );
                return Promise.reject(error);
            }
        );
    },
};